import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { StateCreator } from 'zustand/vanilla';

import { createSelectors } from '@/libs/zustand';
import { StorageStoreDefault } from '@/models/store';

export const SIDEBAR_PERSIST_KEY = 'abonoComSidebar';

interface SidebarState {
    isSidebarOpened: boolean;
}

interface SidebarActions {
    setIsSidebarOpened: (isSidebarOpened: boolean) => void;
}

type StateAndActions = SidebarState & SidebarActions & StorageStoreDefault;

const store: StateCreator<StateAndActions> = (set) => ({
    isSidebarOpened: true,
    isStorageLoaded: false,

    setIsSidebarOpened: (isSidebarOpened) =>
        set((state) => (state.isSidebarOpened !== isSidebarOpened ? { isSidebarOpened } : state)),
    setIsStorageLoaded: () => set((state) => (!state.isStorageLoaded ? { isStorageLoaded: true } : state)),
});

const useSidebarStoreBase = create<StateAndActions>()(
    persist(immer<StateAndActions>(store), {
        name: SIDEBAR_PERSIST_KEY,
        partialize: ({ isSidebarOpened }) => ({ isSidebarOpened }),
        onRehydrateStorage: () => (state) => {
            state?.setIsStorageLoaded();
        },
    }),
);

export const useSidebarStore = createSelectors(useSidebarStoreBase);
